module.exports = __webpack_public_path__ + "static/media/sync.bc366fec.svg";